import React from "react";
import Button from "../../../../components/form/Button";

const Recommendations = ({ title, badge, items }) => {
  return (
    <div className="group relative shadow rounded-lg cursor-pointer transition-all duration-300 border border-transparent flex flex-col px-5 py-5 h-full mb-8">
      <div className="flex flex-wrap gap-3 items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 flex items-center justify-center w-12 md:w-16 aspect-square rounded-lg bg-primary/10 text-primary text-3xl">
            <i className="fa-light fa-lightbulb"></i>
          </div>
          <h3 className="text-xl lg:text-2xl font-bold text-deep-purple font-Montserrat">{title}</h3>
        </div>
        {badge && (
          <span className="text-sm text-primary bg-primary/10 px-3 py-1 rounded-full font-medium">
            {badge}
          </span>
        )}
      </div>
      <div className="space-y-4">
        {items?.map((item, idx) => (
          <div
            key={idx}
            className="bg-primary/5 rounded-md p-6 border border-primary"
          >
            <h4 className="font-bold text-primary mb-2">{item.title}</h4>
            <div className="text-sm text-primary mb-4">{item.description}</div>
            {item.button && (
              <Button
                buttonLabel={item.button.label}
                buttonIcon={item.button.icon}
                buttonIconPosition={item.button.iconPosition || "left"}
                buttonClasses={
                  item.button.classes ||
                  "bg-primary text-white py-3 px-6 rounded-md transition-all duration-300 text-sm font-medium w-full"
                }
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Recommendations;
